import "./App.css";
import { I18nextProvider } from "react-i18next";
import "@mantine/core/styles.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RecipeSuggestions from "./components/recipe/RecipeSuggestions";

import i18n from "utils/i18n/i18nconfig";
import AgentChatView from "components/chat/agent-chat-view";
import { MantineProvider } from "@mantine/core";
import axios from "axios";
import { API_URL } from "utils/constants";
import { CartProvider } from "components/cart/cart-provider";

const onSearch = async (query: string, options: { serviceId: string }) => {
  const { data } = await axios.post(`${API_URL}/search`, {
    query,
    options: { serviceId: options.serviceId },
  });

  return data;

  // return data.map((item: any) => {
  //   return {
  //     id: item.sku || item.id,
  //     name: item.name,
  //     unitAmount: item.amount,
  //     price: {
  //       baseFactor: item.price.basePriceFactor,
  //       discountPercentage: item.price.discountPercentage,
  //       perUnit: item.price.regular.perStandardizedQuantity,
  //       value: item.price.regular.value,
  //       fullValue: item.price.crossed,
  //     },
  //     baseUnit: item.price.baseUnitShort,
  //     baseUnitShort: item.price.baseUnitShort,
  //     volumeLabel:
  //       item.volumeLabel || item.volumeLabelKey || item.volumeLabelLong,
  //     volumeLabelShort: item.volumeLabelShort,
  //     images: item.images,
  //     weight: item.weight,
  //     weightUnit: item.volumeLabelKey,
  //     category: item.category,
  //     maxQuantity: item.maxQuantity,
  //     brand: {
  //       name: item.brand?.name,
  //       nameShort: item.brand?.name,
  //     },
  //   };
  // });
};

const onSearchRecipe = async (
  query: string,
  options: { serviceId: string }
) => {
  const { data } = await axios.post(`${API_URL}/search/recipe`, {
    query,
    serviceId: options?.serviceId,
  });

  return data;
};

// Dummy handlers for test route
const handleAddTest = (id: string) => {
  console.log("Add test:", id);
};

function App() {
  return (
    <BrowserRouter>
      <I18nextProvider i18n={i18n} defaultNS={"translation"}>
        <MantineProvider>
          <CartProvider>
            <Routes>
              <Route
                path="/"
                element={
                  <AgentChatView
                    chatId={"123"}
                    onSearch={onSearch}
                    onSearchRecipe={onSearchRecipe}
                  />
                }
              />
              <Route
                path="/recipe-suggestions"
                element={<RecipeSuggestions onAddToCart={handleAddTest} />}
              />
            </Routes>
          </CartProvider>
        </MantineProvider>
      </I18nextProvider>
    </BrowserRouter>
  );
}

export default App;
